import React from "react";
import LibrarySong from "./LibrarySong";

const Library = ({
  libraryStatus,
  setSongs,
  isPlaying,
  audioRef,
  songs,
  setCurrentSong,
  darkTheme,
}) => {
  return (
    <div
      className={`library ${libraryStatus ? "active-library" : ""}  ${
        darkTheme ? "dark-library" : ""
      }`}
    >
      <h2>Library</h2>
      <div className="library-songs">
        {songs.map((song) => (
          <LibrarySong
            songs={songs}
            song={song}
            setCurrentSong={setCurrentSong}
            id={song.id}
            key={song.id}
            audioRef={audioRef}
            isPlaying={isPlaying}
            setSongs={setSongs}
          />
        ))}
      </div>
    </div>
  );
};

export default Library;
